var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hoursGraphLoading)?_c('v-skeleton-loader',{attrs:{"type":"article"}}):_c('v-card',{staticClass:"shadow rounded-lg"},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('Bar',{attrs:{"labels":_vm.hoursGraph.times,"data":_vm.hoursGraph.values,"title":_vm.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }